// Input: 'yyyy-mm-dd'
const timeFormatObject = {
  '00': '12AM',
  '01': '1AM',
  '02': '2AM',
  '03': '3AM',
  '04': '4AM',
  '05': '5AM',
  '06': '6AM',
  '07': '7AM',
  '08': '8AM',
  '09': '9AM',
  '10': '10AM',
  '11': '11AM',
  '12': '12PM',
  '13': '1PM',
  '14': '2PM',
  '15': '3PM',
  '16': '4PM',
  '17': '5PM',
  '18': '6PM',
  '19': '7PM',
  '20': '8PM',
  '21': '9PM',
  '22': '10PM',
  '23': '11PM',
  '24': '12AM'
};
const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];
const isYesterday = someDate => {
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  const dateParam = new Date(someDate);
  return (
    dateParam.getDate() == yesterday.getDate() &&
    dateParam.getMonth() == yesterday.getMonth() &&
    dateParam.getFullYear() == yesterday.getFullYear()
  );
};
const isToday = someDate => {
  const today = new Date();
  const dateParam = new Date(someDate);
  return (
    dateParam.getDate() == today.getDate() &&
    dateParam.getMonth() == today.getMonth() &&
    dateParam.getFullYear() == today.getFullYear()
  );
};
const isTomorrow = someDate => {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const dateParam = new Date(someDate);
  return (
    dateParam.getDate() == tomorrow.getDate() &&
    dateParam.getMonth() == tomorrow.getMonth() &&
    dateParam.getFullYear() == tomorrow.getFullYear()
  );
};
export const getDate = stringDate => {
  const dateInstance = new Date(stringDate);
  const month = monthNames[dateInstance.getMonth()];
  const date = dateInstance.getDate();
  const yesterday = isYesterday(stringDate);
  const tomorrow = isTomorrow(stringDate);
  const today = isToday(stringDate);
  if (yesterday) {
    return 'Yesterday';
  }
  if (tomorrow) {
    return 'Tomorrow';
  }
  if (today) {
    return 'Today';
  }
  return `${month} ${date}`;
};

export const getTime = (timeInterval, separator = '-') => {
  const splitTime = timeInterval.split(separator);
  return `${timeFormatObject[splitTime[0]]} - ${timeFormatObject[splitTime[1]]}`;
};
